<template>
  <div class="page-product-chart-box">
    <div class="page-header">
        <h2>{{ $t("DashboardProduct.paneltitle1") }}
          <el-button v-if="showcharts" size="mini" @click="hiddencharts()">{{$t("charts.hide")}} <i class="el-icon-arrow-up el-icon--right"></i></el-button>
          <el-button v-if="!showcharts" size="mini" @click="hiddencharts()">{{$t("charts.show")}} <i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <span style="float:right; font-size:14px;">{{$t("charts.latestupdate")}}：{{latestupdatetime}}</span>
        </h2>
    </div>

    <div class="dashboard-row" v-if="showcharts">
      <div class="dashboard-col-200">
        <div class="dashboard-container dashboard-height-400">
          <NumberCard 
            :firsttitle="$t('jgjk.s66')"
            :firstnumber="dashboardModel.total_fakes"
            :firstunit="$t('jgjk.s72')"
            :secondtitle="$t('jgjk.s67')"
            :secondnumber="dashboardModel.fakes_percent"
            :secondunit="$t('DashboardProduct.secondunit')"
            :subid="false"
            :nodata="false"
          />
        </div>
      </div>

      <div class="dashboard-col-auto">
        <el-row>
          <el-col :span="12" style="padding-right:10px;">
            <div class="dashboard-container">
              <div class="dashboard-item">
                <h2>{{ $t('jgjk.s212') }}</h2>
                <div class="dashboard-chart-line-container">
                  <div class="dashboard-chart-line-component" id="myChart"></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" style="padding-left:10px;">
            <div class="dashboard-container">
              <div class="dashboard-item">
                <h2>
                  {{ $t('Seller.t28') }}
                  <el-radio-group style="float: right;" v-model="distributionvalue" 
                    @change="set7ddashboard()" size="mini">
                    <el-radio-button label="1">{{ $t('Seller.t29') }}</el-radio-button>
                    <el-radio-button label="2">{{ $t('Seller.t30') }}</el-radio-button>
                  </el-radio-group>                  
                </h2>
                <div class="dashboard-chart-bar-container">
                  <div class="dashboard-chart-bar-component" id="authdistributionid"></div>
                </div>
              </div>              
            </div>
          </el-col>
        </el-row>
      </div>
    </div><!--dashboard-row-->

    <div class="dashboard-row" v-if="showcharts">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="dashboard-container">
            <div class="dashboard-item">
              <h2>{{ $t('Seller.t2') }}</h2>
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid2"></div>
              </div>
            </div>              
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard-container">
            <div class="dashboard-item">
              <h2>{{ $t('Seller.t3') }}</h2>
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid3"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard-container">
            <div class="dashboard-item">
              <h2>{{ $t('Seller.t4') }}</h2>
              <div class="dashboard-chart-bar-container">
                <div class="dashboard-chart-bar-component" id="barchartid4"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { color } from 'echarts/lib/export'
import NumberCard from '../Charts/NumberCard.vue'
export default {
  components:{
    NumberCard
  },
  data(){
    return{
      latestupdatetime: '',
      showcharts: true,
      queryDate : {
        start_date : this.$store.state.startDate,
        end_date : this.$store.state.endDate
      },
      FakeProductValueTrade: {
        xdatetime: [],
        yvalue: []
      },
      dashboardModel:{
        total_fakes : '',
        fakes_percent : '',
        totalshop_fakes : '',
        fakesshop_percent : ''
      },
      trendChart:{
        type:'line',
      },
      isunauthorized: true,
      barchartdata: [{
        dataitem: [this.$t("Seller.t5"), this.$t("Seller.t6")],
        datavalue:[{
          value: 200,
          itemStyle: {
              color: '#7290F2'
          }
        },{
          value: 150,
          itemStyle: {
              color: '#F49256'
          }
        }]
      },{
        dataitem: [],
        datavalue:[]
      },{
        dataitem: [this.$t("Seller.t7"), this.$t("Seller.t8"), this.$t("Seller.t9")],
        datavalue:[{
          value: 9832,
          itemStyle: {
              color: '#7290F2'
          }
        },{
          value: 2394,
          itemStyle: {
              color: '#F49256'
          }
        },{
          value: 5327,
          itemStyle: {
              color: '#8D7CED'
          }
        }]
      }],
      barchartdatastack: [],

      chartcolors: [
        '#F6924F',
        '#F47373',
        '#7290F2',
        '#8C7BED',
        '#00BFFF',
        '#800080',
        '#FF00FF',
        '#C71585',
        '#FFB6C1',
        '#4B0082'
      ],

      distributionvalue: 2,
      dashauth7d: {},
      dashamount7d: {},
      dashamount7dother: {},
      dashamount7dbychannel: {},
      showbtn2: false,
      showbtn3: false,
      dashbyauth: {},
      dashbychannel: {}
    }
  },

  mounted(){
    let that = this
    let ifshowcharts = JSON.parse(localStorage.getItem("showcharts"))
    if(ifshowcharts === null){
      that.showcharts = true
      that.requestDashboardData(that.$route.params.Id)
    }else{
      that.showcharts = false
      that.requestDashboardData(that.$route.params.Id)
    }
  },

  methods:{

    /**
     * 隐藏图表
     */
    hiddencharts: function(){
      let that = this
      let types = that.showcharts
      if(types === true){
        that.showcharts = false
        that.setLocalStorage( "showcharts", false )
      }else{
        that.showcharts = true
        localStorage.removeItem("showcharts")
        that.requestDashboardData(that.$route.params.Id)
      }
    },

    /**
     * 趋势图
     */
    drawLine(xAxis_data,series_data){
      if(document.getElementById('myChart') === null) return
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.clear()
      myChart.setOption({
        legend: {
          top: 20,
          icon: 'pin'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer:{
            type: 'line',
            lineStyle: {
              color: '#ccc'
            }
          },
        },
        grid:{
          left: 50,
          top:80,
          bottom:30,
          right:30
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis_data
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999',
            fontSize: 12
          }
        },
        series : series_data
      });
      $(window).resize(function () {
        myChart.resize();
      });
    },

    /**
     * 加载 Dashboard 数据
     */
    requestDashboardData: function(subid) {
      let that = this;
      let requestQuery = {
        start: '',
        end: '',
        // start: this.$store.state.startDate+' 00:00:00',
        // end: this.$store.state.endDate+' 23:59:59',
        subid: subid,
      }
      $.ajax({
        url:  this.API_URL + '/v3/price/shop/dashboard',
        type: "GET",
        data: requestQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('------requestDashboardData',rex)

          /**
           * 数字图
           */
          that.dashboardModel.total_fakes = that.millonFormat(rex.results[0][0].FakeShopCount)
          that.dashboardModel.fakes_percent= rex.results[1][0].FakeShopRate

          that.dashboardModel.totalshop_fakes = that.millonFormat(rex.results[2][0].whiteShopCount)
          that.dashboardModel.fakesshop_percent= rex.results[3][0].whiteShopRate

          /**
           * latestupdatetime
           */
          that.latestupdatetime = rex.results[7][0].CurrentDate

          /**
           * 近7天趋势图
           */
          let lineChartData = rex.results[6]
          let yvalue = lineChartData.yvalue.map(function(val, index){
            return {
              color: that.setChannel(val.name).color,
              name: that.setChannel(val.name).loc,
              type: 'line',
              data: val.data
            }
          })
          let xvalue = lineChartData.xdatetime.map((val, index) =>{
            return that.$moment(val).format('MM-DD')
          })
          that.drawLine(xvalue, yvalue)

          /**
           * 授权卖家占比
           */
          that.barchartdata[0].datavalue[0].value = rex.results[8][0].AuthShopCount
          that.barchartdata[0].datavalue[1].value = rex.results[8][1].unAuthShopCount
          that.initBarChartAuthorized(that.barchartdata[0].dataitem, that.barchartdata[0].datavalue, 'barchartid1')

          /**
           * 代购卖家统计占比
           */

          let pieresults = rex.results[9]
          let piechartdataitem = []
          for(let i=0; i<pieresults.length; i++){
            piechartdataitem.push(pieresults[i].Count/1)
          }
          pieresults.forEach(item => {
            item.namestr = that.setDaigouSellersCount(item.ShopLad)
          })
          that.initBarChartAuthorized(pieresults.map(item => {return item.namestr}), piechartdataitem, 'barchartid3')

          /**
           * 地区排行
           */
          let directData = rex.results[10]
          let _directdataitem = []
          let _directdatavalue = []
          for(let x=0; x<directData.length; x++){
            _directdataitem.push(directData[x].SellerLocation)
            _directdatavalue.push(directData[x].count)
          }
          let chartid4data = []
          for(let i=0; i<directData.length; i++){
            let _item = {
              value: directData[i].count,
              itemStyle: {
                  color: that.chartcolors[i]
              }
            }
            chartid4data.push(_item)
          }
          that.initBarChart4(_directdataitem.reverse(), chartid4data.reverse(), 'barchartid4')

          /**
           * 授权卖家占比
           */
          let barresults = [{
            "Channel": "0%-20%",
            "FakeItem": rex.results[5][0],
            "OtherItem": rex.results[4][0]
          },{
            "Channel": "21%-40%",
            "FakeItem": rex.results[5][1],
            "OtherItem": rex.results[4][1]
          },{
            "Channel": "41%-60%",
            "FakeItem": rex.results[5][2],
            "OtherItem": rex.results[4][2]
          },{
            "Channel": "61%-80%",
            "FakeItem": rex.results[5][3],
            "OtherItem": rex.results[4][3]
          },{
            "Channel": "81%-100%",
            "FakeItem": rex.results[5][4],
            "OtherItem": rex.results[4][4]
          }]
          let _d = {
            legenddata0: barresults.length > 0 ? that.$t("Seller.t5") : '',
            legenddata1: barresults.length > 0 ? that.$t("Seller.t6") : '',
            channelname: barresults.map(item => {return item.Channel}),
            data0: barresults.map(item => {return item.FakeItem}),
            data1: barresults.map(item => {return item.OtherItem})
          }
          that.initBarChartStack(_d)

          /**
           * 按授权销售额
           */
          let _byauth = []
          let _channelcolorbyauth = ['#7290F2', '#F49256']
          for(let m=0; m<rex.results[12].yvalue.length; m++){
            let _item = {
              name: rex.results[12].yvalue[m].name == 0 ? that.$t('Seller.t6') : that.$t('Seller.t5'),
              type: 'bar',
              stack: 'total',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: rex.results[12].yvalue[m].data.map(item => {
                return item <= 0 ? 0 : item
              })
            }
            _byauth.push(_item)
          }
          _byauth.reverse()
          let last7daybyauth = {
            xdatetime: rex.results[12].xdatetime.map(item => {
              return that.$moment(item).format('MM-DD')
            }),
            yseries: _byauth,
            color: _channelcolorbyauth
          }
          that.dashbyauth = last7daybyauth

          /**
           * 按平台销售额
           */
          let _bychannel = []
          let _channelcolor = []
          for(let m=0; m<rex.results[11].yvalue.length; m++){
            let _item = {
              name: that.setChannel(rex.results[11].yvalue[m].name).loc,
              type: 'bar',
              stack: 'total',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: rex.results[11].yvalue[m].data.map(item => {
                return item <= 0 ? 0.00 : item
              })
            }
            let _color = that.setChannel(rex.results[11].yvalue[m].name).color
            _bychannel.push(_item)
            _channelcolor.push(_color)
          }
          let last7daybychannel = {
            xdatetime: rex.results[11].xdatetime.map(item => {
              return that.$moment(item).format('MM-DD')
            }),
            yseries: _bychannel,
            color: _channelcolor
          }
          that.dashbychannel = last7daybychannel

          if(that.distributionvalue == 1){
            that.initAuthDistribution(last7daybyauth)
          }
          if(that.distributionvalue == 2){
            that.initAuthDistribution(last7daybychannel)
          }

        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    set7ddashboard: function(){
      let that = this
      if(that.distributionvalue == 1){
        console.log(that.dashbyauth)
        that.initAuthDistribution(that.dashbyauth)
      }
      if(that.distributionvalue == 2){
        console.log(that.dashbychannel)
        that.initAuthDistribution(that.dashbychannel)
      }
    },
    
    /**
     * 地区排行柱状图--竖排
     */
    initBarChart4: function(dataitem, datavalue, cid){
      if(document.getElementById(cid) === null) return
      let myBarChart = this.$echarts.init(document.getElementById(cid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 80,
          top: 20,
          bottom: 20,
          right:20,
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            fontSize: 10
            // interval: 0, // 0 表示显示全部刻度
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          splitLine: {
            show: false
          },
          data: dataitem
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          },
          splitLine: {
            show: false
          },
        },
        series: [{
          data: datavalue,
          type: 'bar',
          barWidth: '50%'
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    },

    /**
     * 授权卖家占比
     */
    initBarChartAuthorized: function(dataitem, datavalue, cid){
      if(document.getElementById(cid) === null) return
      let myBarChart = this.$echarts.init(document.getElementById(cid))
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 50,
          top: 20,
          bottom: 20,
          right:20,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true,
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: dataitem
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [{
          data: datavalue,
          type: 'bar',
          barWidth: '50%'
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    },

    /**
     * 授权卖家折扣程度分布
     */
    initBarChartStack: function(chartdata){
      let myBarChart = this.$echarts.init(document.getElementById('barchartid2'))
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 20,
          icon: 'pin',
          data: chartdata.legenddata
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,//全部显示
            rotate: chartdata.axisLabelrotate
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: chartdata.channelname
          //data: ['JD', 'TB', 'TM']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [
          {
            name: chartdata.legenddata0,
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideRight'
            },
            data: chartdata.data0,
            barWidth: '50%'
          },
          {
            name: chartdata.legenddata1,
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideRight'
            },
            data: chartdata.data1,
            barWidth: '50%'
          }
        ],
        color: chartdata.color ? chartdata.color : ['#7290F2', '#F49256'],
        animation: false
      })
      $(window).resize(function () {
        myBarChart.resize()
      }); 
    },


    /**
     * 授权卖家折扣程度分布
     */
    initAuthDistribution: function(chartdata){
      let that = this
      let myBarChart = this.$echarts.init(document.getElementById('authdistributionid'))
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 20,
          icon: 'pin',
          // data: chartdata.legenddata
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params){
            let _t = []
            for(let i=0; i<params.length; i++){
              let _a = params[i].marker + params[i].seriesName + '：' +  that.formatternumber(params[i].data)
              _t.push(_a)
            }
            return _t.join('<br>')
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,//全部显示
            rotate: chartdata.axisLabelrotate
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: chartdata.xdatetime
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
            formatter: function (value, index) {
              let _v = ''
              if(window.localStorage.getItem('localeLanguage') === 'zh'){
                if(value < 10000){
                  _v = value
                }
                if(value >=10000 && value < 100000000){
                  _v = (value/10000).toFixed(2) + '万'
                }
                if(value >= 100000000){
                  _v = (value/100000000).toFixed(2) + '亿'
                }
              }else{
                if(value < 1000000){
                  _v = value
                }
                if(value >= 1000000 && value < 1000000000){
                  _v = (value/1000000).toFixed(2) + 'M'
                }
                if(value >= 1000000000){
                  _v = (value/100000000).toFixed(2) + 'B'
                }
              }
              return _v
            }
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: chartdata.yseries,
        color: chartdata.color,
        animation: false
      })
      $(window).resize(function () {
        myBarChart.resize()
      }); 
    },

    formatternumber: function(value){
      let _v = ''
      if(window.localStorage.getItem('localeLanguage') === 'zh'){
        if(value < 10000){
          _v = value
        }
        if(value >=10000 && value < 100000000){
          _v = (value/10000).toFixed(2) + '万'
        }
        // if(value >= 1000000 && value < 100000000){
        //   _v = (value/1000000).toFixed(2) + '百万'
        // }
        if(value >= 100000000){
          _v = (value/100000000).toFixed(2) + '亿'
        }
      }else{
        if(value < 1000000){
          _v = value
        }
        if(value >= 1000000 && value < 1000000000){
          _v = (value/1000000).toFixed(2) + 'M'
        }
        if(value >= 1000000000){
          _v = (value/100000000).toFixed(2) + 'B'
        }
      }
      return _v
    },

    /**
     * 求和
     */
    sumNumber: function (arr) {
      var s = 0
      arr.forEach(function(val) {
        s += val
      }, 0)
      return s
    },

  }
}
</script>
